import React from 'react';
export function CampaignSocialPostIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.281 1c-1.184 0-2.386.39-3.23 1.377-.841.983-1.184 2.394-1.004 4.146.19 1.86 1.127 3.475 2.385 4.839 1.255 1.363 2.875 2.526 4.542 3.501l.505.296.505-.296c1.666-.974 3.295-2.136 4.56-3.498 1.267-1.362 2.218-2.977 2.41-4.842.179-1.752-.164-3.163-1.005-4.146C21.105 1.389 19.903 1 18.72 1c-1.207 0-2.177.4-2.896 1.046a4.14 4.14 0 00-.336.34 3.976 3.976 0 00-.323-.333C14.453 1.4 13.489 1 12.28 1zm-2.245 5.319c-.144-1.406.161-2.206.535-2.643.37-.434.95-.676 1.71-.676.736 0 1.21.231 1.53.526.34.311.573.753.7 1.249h1.937c.124-.485.363-.928.712-1.242.334-.3.822-.533 1.559-.533.76 0 1.34.242 1.71.676.374.437.679 1.237.535 2.643-.133 1.293-.802 2.52-1.884 3.684-.966 1.04-2.223 1.986-3.6 2.831-1.375-.844-2.621-1.79-3.578-2.827-1.07-1.163-1.733-2.39-1.866-3.688z"
  }), React.createElement("path", {
    d: "M6 5H1v18h17v-6h-2v4H3V7h3V5z"
  }), React.createElement("path", {
    d: "M12 19H5v-2h7v2zm-7-4h4v-2H5v2z"
  }));
}